var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 454,
    height: 454,
    viewBox: "0 0 454 454",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 227,
    cy: 227,
    r: 219.5,
    fill: "#F8F8FF",
    stroke: "#000471",
    strokeWidth: 15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M343.5 213.01C353.5 218.783 353.5 233.217 343.5 238.99L180 333.387C170 339.161 157.5 331.944 157.5 320.397L157.5 131.603C157.5 120.056 170 112.839 180 118.613L343.5 213.01Z",
    fill: "#000471"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/playButton.56bcbe18d71782ab1266d386e8be2740.svg";
export { ForwardRef as ReactComponent };